





















































































































































































import { Component, Vue } from 'vue-property-decorator';
import DateFormat from "date-fns/format";
import DateSub from "date-fns/subDays";
import {
    VehicleFilter,
    HistoricalVehicleLog,
    HistoricalDealershipLog,
    VehicleStateType,
    getVehicleStateLabel
} from "../../types";
import {
    createVehicleHistoryLog,
    getVehicleHistoryLogs,
    searchByArea,
    searchByAutoGroup,
    searchByDealership
} from "../../endpoints";
import {buildDealershipLink, buildVehicleLink} from "../../path";
import {serializeForm} from "../../util";
import Search from "../utility/Search.vue";

Vue.component("v-search", Search);

@Component
export default class VehicleHistoryLogs extends Vue {

    addVehicleLogForm: {
        vin: string;
        dealership_id: number | null,
        year: string;
        make: string;
        model: string;
        imageUrl: string;
        pageUrl: string;
        price: string;
        vehicleState: string
    } = {
        vin: "",
        dealership_id: null,
        year: "",
        make: "",
        model: "",
        imageUrl: "",
        pageUrl: "",
        price: "",
        vehicleState: VehicleStateType.ACCIDENT
    };

    searchVinModel = "";
    individualVehicleSliderModel = false;

    BuildVehicleLink = buildVehicleLink;
    SearchByDealership = searchByDealership;
    VehicleState = VehicleStateType;
    DateFormat = DateFormat;
    BuildDealershipLink = buildDealershipLink;
    //SearchByDealership = searchByDealership;
    SearchByArea = searchByArea;
    SearchByAutoGroup = searchByAutoGroup;
    GetVehicleStateLabel = getVehicleStateLabel;

    startDateModel = new Date();
    endDateModel = new Date();

    // TODO Initial null result causes refresh
    selectedAreaResult: null | number = null;
    selectedDealershipResult: null | number = null;
    selectedGroupResult: null | number = null;

    logs: HistoricalDealershipLog[] | HistoricalVehicleLog[] = [];

    loadingLogs: boolean = false;

    submitted: boolean = false;

    searchVinTimeout: number;

    mounted() {

        const { start, end, siv } = this.$route.query;

        if(start && end) {
            const startDate = new Date(`${start}T00:00:00`);
            const endDate = new Date(`${end}T00:00:00`);

            // Ensure that the provided dates are valid before attempting to assign them.
            if(!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
                this.startDateModel = startDate;
                this.endDateModel = endDate;
            }
        }

        if(siv) {
            this.individualVehicleSliderModel = true;
        }

        this.onDateChange();
    }

    async onDateChange() {
        const params = new URLSearchParams();

        const formattedStart = DateFormat(this.startDateModel, "yyyy-MM-dd");
        const formattedEnd = DateFormat(this.endDateModel, "yyyy-MM-dd");

        const updatedQueryParams = { ...this.$route.query, start: formattedStart, end: formattedEnd };

        if(this.individualVehicleSliderModel) {
            updatedQueryParams["siv"] = `true`;
        } else {
            delete updatedQueryParams['siv'];
        }

        // Update our query parameters
        this.$router.push({ query: updatedQueryParams });

        params.append("start", formattedStart);
        params.append("end", formattedEnd);

        if(this.selectedAreaResult) {
            params.append("area", `${this.selectedAreaResult}`);
        }

        if(this.selectedDealershipResult) {
            params.append("dealership", `${this.selectedDealershipResult}`);
        }

        if(this.selectedGroupResult) {
            params.append("group", `${this.selectedGroupResult}`);
        }

        if(this.individualVehicleSliderModel) {
            params.append("ungrouped", "true");
        }

        if(this.searchVinModel.length) {
            params.append("vin", this.searchVinModel);
        }

        try {
            this.loadingLogs = true;
            this.logs = await getVehicleHistoryLogs(params.toString());
        } catch (e) {
            console.error(e);
        } finally {
            this.loadingLogs = false;
        }
    }

    debounceSearchVin() {
        window.clearTimeout(this.searchVinTimeout);

        this.searchVinTimeout = window.setTimeout(() => {
            this.onDateChange();
        }, 500);
    }

    onAddManualLogDealershipSelected(item) {
        if(item) {
            this.addVehicleLogForm.dealership_id = item.id;
        }
    }

    onAreaResultSelected(item) {
        if(item) {
            this.selectedAreaResult = item.id;
        } else {
            this.selectedAreaResult = null;
        }

        this.onDateChange();
    }

    onDealershipResultSelected(item) {
        if(item) {
            this.selectedDealershipResult = item.id;
        } else {
            this.selectedDealershipResult = null;
        }

        this.onDateChange();
    }

    onGroupResultSelected(item) {
        if(item) {
            this.selectedGroupResult = item.id;
        } else {
            this.selectedGroupResult = null;
        }

        this.onDateChange();
    }

    buildVehicleLogViewLink(uri: string, date: string) {
        return `${buildDealershipLink(uri)}?start=${date}&end=${date}`
    }

    buildVehicleLogQuickViewLink(uri: string) {
        const date = new Date();
        return `${buildDealershipLink(uri)}?start=${DateFormat(DateSub(date, 14), 'yyyy-MM-dd')}&end=${DateFormat(date, 'yyyy-MM-dd')}&view=${VehicleFilter.LIVE}`
    }

    async onSubmitVehicleLogButtonClick() {

        const payload = JSON.stringify(serializeForm(this.$refs['add-vehicle-history-form'] as HTMLFormElement));

        this.submitted = true;

        await createVehicleHistoryLog(this.addVehicleLogForm.dealership_id, payload);

        this.submitted = false;

        (this.$refs["add-manual-log"] as any).hide();

        (this as any).$bvToast.toast('That is all.', {
            title: 'A new vehicle history log has been created.',
            autoHideDelay: 5000,
            variant: 'secondary',
            solid: true
        });

        this.onDateChange();
    }

    onCreateVehicleHistoryLogModalClose() {
        this.addVehicleLogForm.dealership_id = null;
        this.addVehicleLogForm.vehicleState = VehicleStateType.ACCIDENT;
        this.addVehicleLogForm.price = "";
        this.addVehicleLogForm.year = "";
        this.addVehicleLogForm.make = "";
        this.addVehicleLogForm.model = "";
        this.addVehicleLogForm.pageUrl = "";
        this.addVehicleLogForm.imageUrl = "";
        this.addVehicleLogForm.vin = "";
    }

    onShowIndividualVehiclesChange() {
        this.onDateChange();
    }

    get isAddVehicleLogPriceValid() {
        return this.addVehicleLogForm.price.length > 0 && !isNaN(parseInt(this.addVehicleLogForm.price));
    }

    get isAddVehicleLogVINValid() {
        return this.addVehicleLogForm.vin.length > 0;
    }

    get isAddVehicleLogMakeValid() {
        return this.addVehicleLogForm.make.length > 0;
    }

    get isAddVehicleLogModelValid() {
        return this.addVehicleLogForm.model.length > 0;
    }

    get isAddVehicleLogYearValid() {
        return this.addVehicleLogForm.year.length === 4 && !isNaN(parseInt(this.addVehicleLogForm.year));
    }

}
